import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    // Modal controller connected
  }

  open() {
    try {
      this.dialogTarget.showModal();
    } catch (error) {
      // Error opening modal
    }
  }

  close() {
    try {
      this.dialogTarget.close();
    } catch (error) {
      // Error closing modal
    }
  }
}
